var InputStates = function () {
  var input = Array.prototype.slice.call(document.querySelectorAll('.form__input'));

  var actions = {
    activate (el) {
      el.classList.add('filled');
    },

    deactivate (el) {
      if (el.value === '') el.classList.remove('filled');
    },
  };

  var inputClass = function (el) {
    if (el.value !== '')actions.activate(el);

    el.addEventListener('focus', function addFilled () {
      actions.activate(this);
    });

    el.addEventListener('blur', function removeFilled () {
      actions.deactivate(this);
    });
  };

  input.forEach((el) => {
    inputClass(el);
  });
};

export default InputStates;
